import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from '@infra/auth/auth.service';
import { NavService } from '@infra/nav/nav.service';
import { ThemeService } from '@infra/theme/theme.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private navService: NavService,
    private themeService: ThemeService,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const formularioId = this.navService.getFormId(state.url);

    if(!formularioId) {
      return false;
    }

    if (!this.authService.isAuthenticated) {
      this.router.navigate([this.themeService.identificador]);
      return false;
    }

    if (['minha-conta'].includes(formularioId)) {
      return true;
    }

    const canAccess = this.authService.hasPermission(formularioId, 'CONSULTAR');

    if (!canAccess) {
      this.router.navigate([this.authService.initialRoute]);
      return false;
    }

    return true;
  }
}
